<template>
    <div>
        <h4>To switch to a user, enter their email address.</h4>
        <input v-model="switchUserEmail" type="text">
        <a v-if="validateEmail(switchUserEmail)" class="button success" :href="fullUrl">Switch user</a>
    </div>
</template>

<script>
export default {
  data() {
    return {
      switchUserEmail: "",
      regex: /^\w+([+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    };
  },
  methods: {
    validateEmail(email) {
      // if the email address is valid
      if (this.regex.test(email)) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    fullUrl() {
      // eg https://class4kids.class4kids.co.uk
      var url = window.location.origin;
      // eg /dashboard/
      var path = window.location.pathname;
      // our switch user syntax
      var switchUser = "?_switch_user=";
      // combine it with the email address entered by the user
      var fullUrl = url + path + switchUser + this.switchUserEmail;

      return fullUrl;
    }
  }
};
</script>

<style>
</style>